var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-12"},[_c('h1',[_vm._v("hasil kuliah")]),_c('p',[_vm._v(_vm._s(_vm.$store.state.auth.token))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }